export default "__VITE_ASSET__9a041cfd__"